import { StringsType } from "./en"

export const ar: StringsType = {
  bubbleExpiration: {
    expiredTitle: "انتهت صلاحية Premium المجاني",
    expiredSubtitle: "قم بالترقية إلى Premium للحصول على أفضل تجربة PhotoVault",
    expiredSubtitlePremium:
      "قم بالترقية إلى Premium للحصول على تجربة PhotoVault رائعة",
    expiredSubtitleUltimate:
      "قم بالترقية إلى Ultimate للحصول على أفضل تجربة PhotoVault",
    trashRecovery: "استرجاع المحذوفات",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "بدون إعلانات",
    everyPremiumFeature: "احصل على كل\nميزة Premium",
    everyUltimateFeature: "احصل\n على كل ميزة Ultimate",
    unlockUltimateTools: "افتح جميع أدوات الخصوصية في التطبيق.",
    cloudVaultUltimate: "Cloud Vault - 1,000 GB",
    organizationPlus: "التنظيم+",
    organizationPlusDesc: "إنشاء ألبومات فرعية، والعثور على التكرارات والمزيد.",
    perMonth: "شهرياً",
    perYear: "سنوياً",
    justOnce: "مرة واحدة فقط",
    lifetime: "مدى الحياة",
    threeMonths: "3 أشهر",
    lifetimeTitle: "خطة مدى الحياة",
    lifetimeDescription: "ستكون خطة مدى الحياة متاحة قريباً. ترقبوا التحديثات!",
    lifetimeFeature1: "دفعة واحدة",
    lifetimeFeature2: "وصول مدى الحياة لجميع الميزات",
    lifetimeFeature3: "أفضل قيمة للمستخدمين طويلي المدى",
    lifetimeCta: "شراء Lifetime",
    lifetimeSheetDisclaimer:
      "نسن احتياطي على السحابة (50 جيجابايت) متضمن لمدة 5 سنوات.",
    lifetimeSheetDisclaimerDetailed:
      "5 سنوات من نسخ احتياطي Cloud Vault (50 جيجابايت) متضمنة في خطتك مدى الحياة. بعد ذلك، ستكون مؤهلاً لاشتراك Cloud Vault مخفض متاح فقط لأعضاء مدى الحياة. جميع ميزات Premium ستبقى متاحة دائماً بدون تكلفة إضافية.",
    lifetimeDisclaimerCloudStorage:
      "5 سنوات من نسخ احتياطي Cloud Vault (50 جيجابايت) متضمنة في خطتك مدى الحياة.",
    lifetimeDisclaimerAfterPeriod:
      "بعد 5 سنوات، ستكون مؤهلاً لاشتراك Cloud Vault مخفض متاح فقط لأعضاء مدى الحياة.",
    lifetimeDisclaimerPremiumFeatures:
      "جميع ميزات Premium ستبقى متاحة دائماً بدون تكلفة إضافية.",
    monthly: "شهري",
    yearly: "سنوي",
    selectPlan: "اختر خطة للمتابعة",
    unlockPrivacyTools: "فتح أدوات الخصوصية الممتازة.",
    cloudVaultGB: "Cloud Vault - 50 جيجابايت",
    secureBackups: "نسخ احتياطية آمنة تبقى مشفرة.",
    freeUpSpace: "حرر مساحة على هاتفك.",
    recoverDeleted: "استرجع العناصر المحذوفة من سلة المحذوفات.",
    fullExperience: "التجربة الكاملة بدون انقطاعات.",
    restorePurchases: "استعادة المشتريات",
    basicTitle: "Private Photo Vault أساسي",
    free: "مجاني",
    basicDescription:
      "أساسي هو النسخة المجانية من PhotoVault. لا يزال يحمي صورك المهمة خلف شاشة PIN ويعطيك ميزات خصوصية جيدة.",
    switchToBasic: "انتقل إلى أساسي",
    termsOfService: "شروط الخدمة",
    privacy: "الخصوصية",
    switchToPremium: "الترقية إلى Premium",
    switchToUltimate: "الترقية إلى Ultimate",
    premiumExpiredTitle: "انتهت صلاحية Premium",
    ultimateExpiredTitle: "انتهت صلاحية Ultimate",
    renewSubtitle: "جدد للحصول على أفضل تجربة Private Photo Vault",
    selectPlanOrSwitchToPro: "اختر خطة أو انتقل إلى Pro مجانًا",
    selectPlanOrSwitchToBasic: "اختر خطة أو انتقل إلى Basic مجانًا",
    proTitle: "Private Photo Vault - Pro",
    purchased: "تم الشراء",
    proDescription:
      "نظرًا لأنك اشتريت مسبقًا إصدار Pro لمرة واحدة، ستتمكن من الاستمرار في استخدام جميع ميزات Pro التي دفعت ثمنها سابقًا.",
    switchToPro: "التبديل إلى Pro",
    subscribeFor: (price: string) => `اشترك بـ ${price}/سنة`,
    subscribeForMonth: (price: string) => `اشترك بـ ${price}/شهر`,
    billedPerYear: (price: string) => `يُدفع ${price} سنوياً`,
    oneStepSubtitle:
      "قم بالترقية إلى بريميوم للحصول على أفضل\nتجربة Private Photo Vault",
    oneStepSubtitleUltimate:
      "قم بالترقية إلى Ultimate للحصول على أفضل\nتجربة Private Photo Vault",
    purchaseWithAppStore: "الشراء عبر App Store",
  },
  title: "وصول غير محدود إلى جميع الميزات",
  freeTrial: "محاولة مجانية",
  startPlan: "ابدأ الخطة",
  pricePerMonth: (price: any) => `${price}/شهر`,
  pricePerYear: (price: any) => `يتم تحصيل ${price}/سنة`,
  freeTrialDescriptionYearly: (days: number, price: string) =>
    `${days} أيام مجانًا ثم ${price}/سنة. ألغ في أي وقت`,
  freeTrialDescriptionMonthly: (days: number, price: string) =>
    `${days} أيام مجانًا ثم ${price}/شهر. ألغ في أي وقت`,
  discount: (discount: number) => `"خصم ${discount}%`,
  new: "جديد",
  trashRecovery: "استعادة المحذوفات",
  adFree: "تجربة خالية من الإعلانات",
  breakIn: "تقرير الاختراق: الصور والـGPS",
  wireless: "نقل الصور لاسلكياً",
  decoy: "رمز مرور Decoy",
  pattern: "Pattern Lock",
  appDisguise: "تمويه التطبيق",
  comingSoon: "قريباً",
  subscriptionTerms: "شروط الاشتراك:",
  terms:
    "سيتم فرض الدفع على حساب iTunes عند تأكيد الشراء. سيتم تجديد الاشتراك تلقائيًا ما لم يتم إيقاف التجديد التلقائي قبل 24 ساعة على الأقل من نهاية الفترة الحالية. سيتم فرض رسوم التجديد في غضون 24 ساعة قبل نهاية الفترة الحالية. يمكنك إدارة اشتراكك وإيقاف التجديد التلقائي عن طريق الانتقال إلى إعدادات حسابك بعد الشراء.",
  privacy: "الخصوصية",
  alreadyPurchased: "تم شراؤه بالفعل؟",
  termsButton: "الشروط",
  monthly: "شهرياً",
  yearly: "سنوياً",
  popular: "شائع",
  save: (discount) => `وفّر ${discount}%`,
  anniversaryTitle: (discount) => `صفقة الذكرى - وفّر ${discount}%`,
  blackFridayTitle: (discount) => `الجمعة السوداء - وفّر ${discount}%`,
  year: "سنة",
  years: "سنوات",
  hour: "ساعة",
  hours: "ساعات",
  minute: "دقيقة",
  minutes: "دقائق",
  second: "ثانية",
  seconds: "ثواني",
  promoSubtitle: (hours) => `اسرع، سيستمر هذا العرض لمدة ${hours} ساعة فقط`,
  offerExpires: "حتى انتهاء العرض",
  unlockDeal: "فتح الصفقة",
  blackFridayPaywallTitle: "عرض الجمعة السوداء",
  anniversaryPaywallTitle: "عرض الذكرى 🎉",
  blackFridayPaywallSubtitle:
    "لا تفوت هذا العرض الذي يحدث مرة واحدة في عرض الجمعة السوداء! احصل على توفير كبير على اشتراكنا السنوي.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `تهانينا على ${years} سنوات معنا! للاحتفال، إليك خصم بنسبة ${discount}% على الاشتراك الرئيسي. شكرًا لولائك!`,
  blackFridayAnnualTitle: "عرض الجمعة السوداء الخاص بك 🎉",
  anniversaryAnnualTitle: "عرض الذكرى الخاص بك 🎉",
  oneYear: "سنة واحدة",
  oneMonth: "شهر واحد",
  lockedIn: "سيتم قفل هذا السعر السنوي إلى الأبد",
  subtitleFixed: "أسرع، ستنتهي هذه البيعة قريباً!",
  importTitle: "ابدأ خزنتك",
  importSubtitle: "إنها خاصة بنسبة 100%!",
  importInfo: "أضف الصور ومقاطع الفيديو التي تريد إخفاءها وحمايتها.",
  importCTA: "أضف إلى الخزنة",
  skip: "تخطي",
  totalMonthsPrice: (price: string) => `12 شهر • ${price}`,
  monthlyPrice: (price: string) => `${price} / شهر`,
  oneTimeOffer: {
    title: "عرض لمرة واحدة",
    subTitle: "بمجرد إغلاق العرض لمرة واحدة، سيختفي!",
    claim: "اطلب عرضك لمرة واحدة",
  },
  returnOffer: {
    monthly: (price: string) => `بأقل من ${price}/شهر`,
    title: "عرض العودة الحصري",
    subTitle: "أعد تفعيل عضويتك اليوم بسعر خاص! متاح لفترة محدودة فقط",
    discountTitle: "خصم خاص",
    cta: "أعد التفعيل الآن",
    discountSubTitle: "عرض لفترة محدودة",
  },
  off: "خصم",
  special: "خاص",
  yearlyPlan: "الخطة السنوية",
  monthlyPlan: "الخطة الشهرية",
  subscribe: "اشتراك",
  cancelAnytime: "إلغاء في أي وقت",
  freeTrialPaywall: {
    title: "كيف تعمل تجربتك المجانية",
    firstStep: {
      title: "الآن",
      subtitle:
        "افتح الوصول غير المحدود إلى Private Photo Vault ولا تقلق أبدًا من رؤية أي شخص لصورك الخاصة مرة أخرى",
    },
    secondStep: {
      title: "اليوم: ابدأ تجربتك المجانية",
      subtitle:
        "افتح الوصول الكامل إلى PhotoVault. لن يتم تحصيل أي رسوم منك اليوم.",
    },
    thirdStep: {
      title: "في غضون 7 أيام",
      subtitle:
        "سيتم تحصيل الرسوم منك في هذا اليوم. يمكنك الإلغاء في أي وقت قبل ذلك بدون أي متاعب.",
    },
    whatsIncluded: "شاهد ما هو مشمول",
    viewAllPlans: "عرض جميع الخطط",
    startTrial: "ابدأ التجربة المجانية",
    footerTitle: (yearlyPrice: string, monthlyPrice: string) =>
      `7 أيام مجانية ثم ${yearlyPrice}/سنة\n(${monthlyPrice} شهريًا)`,
    footerDisclaimer:
      "يمكنك الإلغاء في أي وقت قبل انتهاء التجربة. سيتم تحصيل الرسوم منك بعد 7 أيام فقط",
    featureList: {
      title: "ما هو Private Photo Vault؟",
      infoTitle: "خاص وآمن بنسبة 100%",
      infoSubtitle: "احمِ بياناتك ومنع الوصول غير المصرح به",
      subTitle: "احصل على النسخة المميزة والوصول إلى:",
    },
    comparePlans: {
      monthly: "شهريًا",
      yearly: "سنويًا",
      ultimateYearly: "Ultimate السنوي",
      threeMonths: "3 أشهر",
      freeFor: (days: number) => `مجاني لمدة ${days} يومًا`,
      monthlyPrice: (price: string) => `فقط ${price}/شهر`,
      dailyPrice: (price: string) => `فقط ${price}/يوم`,
      cta: "استمر",
    },
  },
  comparePlans: {
    title: "مقارنة الخطط",
    compare: "مقارنة",
    freeTitle: "مجاني",
    basicTitle: "أساسي",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "افتح Premium",
    unlockUltimate: "افتح Ultimate",
    choose: " اختر خطة",
  },
  features: {
    organizationPlus: "تنظيم+",
    securityPlus: "أمان+",
    duplicateDetection: "كشف التكرار",
    faceDownLock: "قفل بوضع الشاشة لأسفل",
    customIcons: "رموز مخصصة",
    encryptedStorage: "تخزين الصور المشفر",
    unlimitedAlbums: "ألبومات غير محدودة",
    browser: "متصفح ويب آمن",
    camera: "كاميرا خاصة",
    subalbums: {
      title: "الألبومات الفرعية",
      description:
        "أنشئ مستويات متعددة من الألبومات الفرعية لتنظيم المحتوى بكفاءة.",
    },
    filteringAndSearching: {
      title: "التصفية والبحث",
      description:
        "ابحث في ألبوماتك وطبق الفلاتر للعثور على أنواع معينة من المحتوى.",
    },
    alphanumericPasscode: {
      title: "رمز المرور الأبجدي الرقمي",
      description: "عزز أمان التطبيق الخاص بك باستخدام كلمة مرور أبجدية رقمية.",
    },
    dualLock: {
      title: "يتطلب رمز المرور + Face ID",
      description:
        "لأمان إضافي، يتطلب كل من رمز المرور وFace ID في كل مرة تدخل فيها إلى التطبيق.",
    },
    locationBasedLock: {
      title: "قفل بناءً على الموقع",
      description: "السماح بفتح التطبيق فقط في المواقع المحددة بنظام GPS.",
    },
  },
  gotIt: "فهمت!",
  promo: {
    premiumSave: (percent: string) => `وفر ${percent}% على PREMIUM`,
    monthly: (price: string) => `فقط ${price} / شهر`,
    yearly: (price: string) => `${price} / سنة`,
    limited: "الوقت المتبقي محدود",
    claimOffer: "احصل على العرض",
    seconds: (count: number) => (count == 1 ? "ثانية" : "ثواني"),
    minutes: (count: number) => (count == 1 ? "دقيقة" : "دقائق"),
    oneTimeOffer: "عرض لمرة واحدة",
    normalFee: "الرسوم العادية",
    backTo: "العودة إلى",
    yearlyShort: (price: string) => `${price} / سنوي`,
  },
  premiumToUltimateBlackFriday: {
    title: "تخفيضات الجمعة السوداء",
    subTitle: "اذهب إلى ULTIMATE",
    cloud: {
      title: "سعة تخزين سحابية 1,000 جيجابايت",
      description: "تخزين سحابي آمن لأكثر من 500,000 صورة",
    },
    duplicateDetection: {
      description: "حدد وأزل الصور المكررة",
    },
    organizationPlus: {
      description: "أنشئ ألبومات فرعية، وقم بالتصفية وابحث في صورك",
    },
    securityPlus: {
      description:
        "أمان معزز بكلمة مرور أبجدية رقمية، وقفل مستند إلى الموقع والمزيد",
    },
    timeRemaining: "الوقت المتبقي",
    saleBanner: "عرض ضخم لفترة محدودة",
    saleTitle: "تخفيضات الجمعة السوداء 🎉",
    bannerTitle: (discount: number) => `خصم ${discount}% في الجمعة السوداء`,
    bannerCTA: "احصل على العرض",
    monthPrefix: "12 شهر • ",
    perMonthPrice(price: string) {
      return `${price} / شهر`
    },
    monthly: "شهري",
    ultimateLaunch: {
      title: "الترقية إلى Ultimate",
      saleTitle: "عرض إطلاق Ultimate 🚀",
      bannerTitle: (discount) => `إطلاق Ultimate - وفر ${discount}%`,
    },
  },
  blackFridayNoFeatures: {
    title: "BLACK FRIDAY",
    lessThanCoffee: "أقل من فنجان قهوة.",
    dontWait: "لا تنتظر! سينتهي هذا العرض قريبًا",
    whatWaiting: "ماذا تنتظر؟",
    claimOffer: "احصل على عرضك لمرة واحدة",
    moneyBack: "ضمان استرداد الأموال",
  },
  cyberMonday: {
    title: "CYBER MONDAY",
    subTitle: "احصل على Ultimate",
    cloud: {
      title: "سعة تخزين سحابية 1000 جيجا",
      description: "تخزين سحابي آمن لأكثر من 500,000 صورة",
    },
    duplicateDetection: {
      description: "البحث عن الصور المكررة وإزالتها",
    },
    organizationPlus: {
      description: "إنشاء ألبومات فرعية وتصفية والبحث في صورك",
    },
    securityPlus: {
      description:
        "أمان معزز مع رمز مرور أبجدي رقمي وقفل بناءً على الموقع والمزيد",
    },
    timeRemaining: "الوقت المتبقي",
    saleBanner: "عرض سايبر محدود الوقت",
    saleTitle: "عرض Cyber Monday",
    bannerTitle: (discount: number) => `خصم ${discount}% في Cyber Monday`,
    bannerCTA: "احصل على العرض",
    monthPrefix: "12 شهر • ",
    perMonthPrice(price: string) {
      return `${price} / شهر`
    },
    monthly: "شهري",
    ultimateLaunch: {
      title: "الترقية إلى Ultimate",
      saleTitle: "عرض إطلاق Ultimate",
      bannerTitle: (discount: number) =>
        `الترقية إلى Ultimate - وفر ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "انتظر قليلاً - قبل أن تغادر",
    subtitle: "احفظ صورك بأمان وخصوصية",
    subtitle2: "احصل على 7 أيام مجانية من الخدمة الممتازة.",
    cta: "ابدأ تجربتك المجانية",
    cancelTitle:
      "يمكنك الإلغاء في أي وقت قبل انتهاء التجربة ولن يتم محاسبتك حتى تنتهي الـ7 أيام.",
    skipCta: "لا شكرا",
  },
  enableTrial: "لست متأكدًا بعد؟ فعّل التجربة المجانية",
  startTrial: "ابدأ التجربة المجانية",
  trialActivated: (days) => `تم تفعيل تجربة ${days} يوم`,
  specialOffer: {
    enabledTitle: "تم تفعيل العرض الخاص",
    trialTitle: "احصل على تجربة مجانية إضافية لمدة 7 أيام",
    expirationTitle: "اشتراكك سينتهي قريبًا!",
    expirationSubtitle: "جدد اشتراكك بسعر خاص!",
    priceBoxExpiration: {
      title: "عرض تجديد خاص",
      offerName: "الخطة السنوية",
      ctaTitle: "احصل على العرض الخاص",
    },
    priceBoxTrial: {
      title: "عرض تجربة مجانية إضافية لمدة 7 أيام",
      offerName: "تجربة مجانية لمدة 7 أيام إضافية",
      ctaTitle: "احصل على التجربة المجانية الإضافية",
    },
  },
  premiumToUltimate: {
    titleLine1: "ترقية ULTIMATE",
    titleLine2: "عرض لمرة واحدة",
    megaSaleBanner: "تخفيض ضخم لفترة محدودة",
    upgradeTitle: "عرض ترقية Ultimate",
    yearlySubtitlePrefix: "١٢ شهر •",
    monthlyPriceSuffix: "/ شهريًا",
  },
  monthlyToYearly: {
    titleLine1: "ترقية إلى الخطة السنوية",
    titleLine2: "عرض لمرة واحدة",
    subtitleWarning: "بمجرد إغلاق عرضك لمرة واحدة، سيختفي!",
    specialLabel: "مميز",
    offerTitle: "احصل على عرضك لمرة واحدة",
    offerName: "الخطة السنوية",
    subscribeButton: "اشترك",
    cancelAnytime: "يمكنك الإلغاء في أي وقت",
    yearlySubtitlePrefix: "١٢ شهر •",
    monthlyPriceSuffix: "/ شهريًا",
  },
  expiration: {
    warmup: {
      close: "إغلاق",
      subtitle: "احتفظ بصورك آمنة وقابلة للاسترداد إذا فُقد هاتفك أو سُرق",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "نسخة احتياطية مشفرة لملفاتك",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "سعة تخزين Cloud Vault 1000 جيجابايت",
        },
        reviews: {
          title: "أكثر من 500,000 تقييم 5 نجوم",
          subtitle: "موثوق به من قبل الملايين",
        },
        noAds: {
          title: "بدون إعلانات",
          subtitle: "تجربة خالية من الإعلانات",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "ألبومات فرعية، تصفية محسّنة، والمزيد",
        },
      },
      footer: "وكل ميزة أخرى!",
      switchToPremium: "الترقية إلى Premium",
      switchToUltimate: "الترقية إلى Ultimate",
      titlePremium: "انتهت صلاحية Premium!",
      titleUltimate: "انتهت صلاحية Ultimate!",
      popular: "الأكثر شيوعًا",
      perMonth: "شهريًا",
      perYear: "سنوياً",
    },
    titlePremium: "انتهت صلاحية Premium",
    titleUltimate: "انتهت صلاحية Ultimate",
    subtitlePremium:
      "قم بتجديد Premium للاحتفاظ بجميع ميزاتك، أو انتقل إلى Basic مجانًا",
    subtitleUltimate:
      "قم بتجديد Ultimate للاحتفاظ بجميع ميزاتك، أو انتقل إلى Basic مجانًا",
    basicButton: "الانتقال إلى Basic",
    basicTitle: "ما هو Basic؟",
    basicDescription:
      "Basic هو الإصدار المجاني من التطبيق. لا يزال يمكنك من حماية صورك وفيديوهاتك برمز PIN. ومع ذلك، ستفقد الوصول إلى Cloud Vault المشفر وجميع ميزات Premium الأخرى",
  },
  animated: {
    title: "اختر خطتك",
    yearlyPrice: (price: string) => `فقط ${price} سنويًا`,
    subtitle: "تتجدد تلقائيًا. يمكنك الإلغاء في أي وقت",
    cta: "استمر",
    trial: "تم تفعيل الفترة التجريبية المجانية",
    breakinShort: "تقرير الاقتحام",
    unlimitedPhotos: "صور غير محدودة",
  },
  choosePlanTitle: "اختر خطتك",
  socialProof: {
    titleWithTrial: "جرّب Private Photo Vault\nمجاناً لمدة 7 أيام",
    title: "جرّب Private Photo Vault",
    continueForFree: "المتابعة مجاناً",
    continue: "متابعة",
    cancelAnytime: "إلغاء في أي وقت",
    mostPopular: "الأكثر شعبية",
    twelveMonths: "12 شهر",
    oneMonth: "شهر واحد",
    yearlySubtitle: (monthlyPrice: string, yearlyPrice: string) =>
      `${monthlyPrice}/شهر، يُفوتر بـ ${yearlyPrice}/سنة`,
    monthlySubtitle: (price: string) => `${price}/شهر`,
  },
  yearlyOnlyAppStore: {
    yearly: "سنوي",
    billedYearly: (price: string) => `${price} يُحصّل سنويًا`,
    perMonth: (price: string) => `${price}/شهر`,
    startTrial: (days: number) => `ابدأ تجربة ${days} أيام`,
    purchaseWithAppStore: "الشراء عبر App Store  (بدون تجربة)",
    purchaseImmediately: "اشترِ الآن  (بدون تجربة)",
  },
  multistep: {
    lockTitle: "قفل الصور الخاصة",
    subtitle: {
      line1: "نقدّم",
      line2: "7 أيام مجانًا",
      line3: "حتى يتمكن الجميع من حماية صورهم",
    },
    subtitleReminder: {
      line1: "سوف نرسل تذكيرًا ",
      line2: "قبل يومين ",
      line3: "من انتهاء الفترة التجريبية.",
    },
    noPaymentNow: "لا حاجة للدفع الآن",
    startFreeWeek: "ابدأ أسبوعك المجاني",
    payTitle: "7 أيام مجانًا",
    afterPrice: (price: string) => `ثم ${price} / شهريًا`,
    afterBilling: (price: string) => `(يتم تحصيل ${price} سنويًا بعد التجربة)`,
    footerTitle: (price) => `مجاني لمدة 7 أيام. ثم ${price}/سنة`,
    footerMonthlyTitle: (price) => `سيتم خصم ${price} فورًا.`,
    headerTitle: "تجربة مجانية لمدة 7 أيام",
    anual: "سنوي",
    monthly: "شهري",
    noTrial: "بدون تجربة مجانية",
    yearlyPrice: (price) => `${price} / سنة`,
  },
  oneTimeOfferTitle: "عرض لمرة واحدة",
  unlockPremiumFor: "افتح Premium السنوي مقابل",
  oneTimeOfferSubtitle: "هذا عرض لمرة واحدة",
  lowestPrice: "أقل سعر على الإطلاق",
  summerSale: {
    title: "تخفيضات الصيف",
    tagline: "الشمس ترى كل شيء... إلا ما في خزنتك!",
    timeRemaining: "ينتهي العرض قريباً",
    limitedTimeOffer: "عرض لفترة محدودة",
    savePercent: (percent: number) => `وفّر ${percent}%`,
    bannerSubtitle: (price: string) => `احصل على Premium مقابل ${price}`,
    bannerSubtitleUltimate: (price: string) =>
      `احصل على Ultimate مقابل ${price}`,
    getPremium: "احصل على الخصوصية Premium",
    getUltimate: "احصل على الخصوصية Ultimate",
    hours: "ساعات",
    minutes: "دقائق",
    seconds: "ثواني",
    features: {
      premiumFeature: {
        title: "احصل على جميع ميزات Premium",
        description: "أدوات Premium التي تحمي خصوصيتك.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 جيجابايت",
        description: "نسخ احتياطية آمنة تبقى مشفرة.",
      },
      noAds: {
        title: "بدون إعلانات",
        description: "التجربة الكاملة بدون انقطاع.",
      },
      faceDownLock: {
        title: "قفل الوجه لأسفل",
        description: "قفل التطبيق فوراً بقلب هاتفك.",
      },
      breakInReports: {
        title: "تقارير الاختراق",
        description: "تنبيهات إذا حاول شخص الوصول إلى خزنتك.",
      },
    },
    pricing: {
      summerSale: "تخفيضات الصيف",
      monthly: "شهري",
      perMonth: (price: string) => `${price} / شهر`,
      twelveMonths: "12 شهر",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  autumnSale: {
    title: "تخفيضات الخريف",
    tagline: "الأوراق تغطي كل شيء…\nبما في ذلك أسرارك!",
    buttonTitle: "تخفيضات الخريف",
  },
  halloweenSale: {
    title: "تخفيضات هالوين",
    tagline: "الليل يخفي أشياء كثيرة…\nخاصة أشياءك!",
    buttonTitle: "تخفيضات هالوين",
  },
  winterSale: {
    title: "تخفيضات الشتاء",
    tagline: "لنحمِ صورك تحت الثلج",
    buttonTitle: "تخفيضات الشتاء",
  },
  springSale: {
    title: "تخفيضات الربيع",
    tagline: "قم بالترقية إلى بريميوم مع خصم الربيع الحصري",
    ultimateTagline: "قم بالترقية إلى ألتيميت مع خصم الربيع الحصري",
    buttonTitle: "تخفيضات الربيع",
  },
  emailPromo: {
    title: "عرض Premium حصري",
    upgradeButton: "الترقية إلى Premium",
    yearlyTitle: "Premium سنوي",
    decoyDescription: "إنشاء خزنة مزيفة تُفتح بكلمة مرور طُعم",
  },
  tabsPaywall: {
    premiumTab: "Premium",
    ultimateTab: "Ultimate",
    premiumTitle: "افتح Premium لـ",
    premiumTitleHighlight: "تأمين خزنتك",
    ultimateTitleStart: "افتح ",
    ultimateTitleHighlight: "Ultimate",
    ultimateTitleEnd: " للوصول\nإلى جميع الميزات",
    perMonth: "/شهر",
  },
  trialFooter: {
    freeTrialDays: (days: number) => `${days} يوم\nتجربة مجانية`,
    noFreeTrial: "لا توجد تجربة\nمجانية",
    noCommitment: "بدون التزام. يمكنك الإلغاء في أي وقت.",
    cta: "جرّب مجانًا",
    ctaMonthly: "متابعة",
    yearly: "سنوي",
    monthly: "شهري",
  },
  onboardingUltimateAlternate: {
    title: "ابدأ تجربتك المجانية",
    premiumDescription: "افتح أدوات خصوصية ممتازة.",
    ultimateDescription: "أفضل تجربة Photo Vault.",
    includesPremium: "يتضمن Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 أيام مجانًا، ثم ${yearlyPrice} (${monthlyPrice}/شهر)`,
    timeline: {
      today: "اليوم:",
      todayDescription: "ابدأ تجربتك المجانية",
      day5: "اليوم 5:",
      day5Description: "احصل على تذكير",
      day7: "اليوم 7:",
      day7Description: (yearlyPrice: string) => `سيتم تحصيل ${yearlyPrice} منك`,
    },
    comparisonTable: {
      header: "ما تحصل عليه",
    },
    didYouKnow: {
      label: "هل تعلم؟",
      statNumber: "3 أضعاف",
      statDescription: "يحصل المشتركون على 3 أضعاف راحة البال",
    },
    pricing: {
      yearlyPlanTitle: "الخطة السنوية",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/سنة`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/شهر`,
      monthlyTitle: "شهري",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/شهر`,
      popularBadge: "شائع",
    },
    ctaButton: "ابدأ التجربة المجانية",
  },
  threeStepExpiration: {
    premiumExpired: "انتهت صلاحية Premium الخاص بك",
    ultimateExpired: "انتهى اشتراك Ultimate",
    freeExpired: "انتهت صلاحية Premium المجاني",
    subtitle: "تم تخفيض حسابك.",
    subtitlePremium: "تم تخفيض حسابك.",
    subtitleUltimate: "تم تخفيض حسابك.",
    allPremiumFeatures: "جميع ميزات Premium",
    allUltimateFeatures: "جميع ميزات Ultimate",
    spaceSaver: "موفر المساحة",
    disabled: "معطّل",
    restoreMyProtection: "استعادة الوصول الكامل",
    seeWhatImLosing: "عرض ما سأفقده",
    photosSafeWarning: "صورك آمنة، لكن الميزات الحيوية معطّلة الآن.",
    continue: "متابعة",
    heresWhatYoureLosing: "إليك ما ستفقده",
    allFeaturesDisabled: "سيتم تعطيل جميع ميزات Premium هذه في حسابك:",
    allFeaturesDisabledUltimate: "سيتم تعطيل جميع ميزات Ultimate هذه في حسابك:",
    back: "رجوع",
    stepOf: (current: number, total: number) => `الخطوة ${current} من ${total}`,
    restoreAllFeatures: "استعادة جميع الميزات",
    continueWithout: "متابعة (تبقى الميزات معطّلة)",
    allPremiumDetail:
      "ستفقد الوصول إلى جميع ميزات Premium التي تحافظ على صورك الخاصة آمنة ومنظمة.",
    cloudVaultDetail:
      "سيتم حذف النسخة الاحتياطية السحابية. إذا فُقد جهازك أو تعرض للتلف، ستُفقد صورك الخاصة نهائياً.",
    cloudVaultDetailBold: "سيتم حذف النسخة الاحتياطية السحابية.",
    cloudVaultDetailRest:
      "إذا فُقد جهازك أو تعرض للتلف، ستُفقد صورك الخاصة نهائياً.",
    spaceSaverDetail:
      "ستشغل الصور كامل مساحة التخزين على جهازك. لن تتمكن بعد الآن من ضغط وتحسين خزنتك.",
    trashDetail:
      "لن يمكن استرداد الصور المحذوفة عن طريق الخطأ. بمجرد حذفها، ستُفقد نهائياً.",
    noAdsDetail:
      "ستبدأ في رؤية إعلانات في جميع أنحاء التطبيق. يزيل Premium جميع الإعلانات لتجربة بدون انقطاع.",
    decoyDetail:
      "سيتوقف رمز الطُعم عن العمل. يمكن لأي شخص يعرفه الوصول إلى خزنتك الحقيقية.",
    chooseYourPlan: "اختر خطتك",
    restoreFullProtection: "استعادة الحماية الكاملة فوراً",
    restorePremiumInstantly: "استعادة Premium فوراً",
    restoreUltimateInstantly: "استعادة Ultimate فوراً",
    instantlyRestored: "تمت الاستعادة فوراً",
    reassurance:
      "استأنف من حيث توقفت — سيتم استعادة كل ميزة بالكامل لحظة اشتراكك.",
    subscribeAndRestore: "اشترك واستعد",
    scrollForMore: "مرر لعرض المزيد",
    bestValue: "أفضل قيمة",
    switchToBasicDescription:
      "ستظل قادراً على عرض والوصول إلى جميع صورك الحالية في التطبيق. ألبوماتك ووسائطك تبقى آمنة على جهازك.",
    viewAndAccess: "عرض والوصول إلى جميع صورك الحالية",
    premiumFeaturesDisabled: "",
    restorePremium: "استعادة Premium",
    restoreUltimate: "استعادة Ultimate",
    choosePlanToReactivate: "اختر خطة لإعادة تفعيل جميع الميزات",
    perMonth: "/شهر",
    twelveMonths: "سنوي",
    oneMonth: "شهر واحد",
  },
  backupPaywall: {
    title: "النسخ الاحتياطي غير مفعّل",
    subtitle:
      "صورك ومقاطع الفيديو غير محفوظة. اشترك في Premium لتفعيل النسخ الاحتياطي وفتح جميع الميزات",
    subscribe: "احصل على Premium",
    cancelAnytime: "بدون التزام. يمكنك الإلغاء في أي وقت",
  },
  lossAversion: {
    title: "لم يتم نسخ أي صورة احتياطيًا\nعلى الإطلاق.",
    subtitle: "كل صورة مخزنة فقط على هذا الجهاز. إذا فقدته، ستختفي إلى الأبد.",
    photosUnprotected: "صور\nغير محمية",
    backedUp: "تم نسخها احتياطيًا",
    daysAtRisk: "أيام في خطر",
    backupCoverage: "تغطية النسخ الاحتياطي",
    vaultProtected: (percent: number) => `${percent}% من خزنتك محمي`,
    premiumTitle: "ما تحصل عليه مع Premium",
  },
}
